import DataLayer from '@lego/js/services/DataLayer';

export default {
    created() {
        this.$events.listen(
            'add-to-cart',
            async ({ product, productVariant, addOnProductVariants, currency }) => {
                await this.services.dataLayer.addToCart(
                    product,
                    productVariant,
                    addOnProductVariants,
                    currency
                );
                await this.services.zaius.addToCart(product.shopify_id);

                window.location.href = '/cart';
            }
        );

        this.$events.listen('email-captured', email => {
            this.services.heap.identify(email);
            this.services.zaius.subscribe(email);

            Sentry.configureScope(scope => {
                scope.setUser({ email: email.toLowerCase() });
            });
        });

        this.$events.listen('variant-selected', variant => {
            DataLayer.push({
                variant_id: variant.shopify_id,
                price: variant.price.amountInCents / 100,
                sku: variant.sku,
            });
        });
    },
};
